import { useSearchParams } from 'react-router-dom';

import type { FilterStatusType } from '@/app/types/TaskStatusFilter';

import { ButtonsSelect } from '@/components/Elements/ButtonSelect';

export const TasksToolbar = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const status = (searchParams.get('status') as FilterStatusType) ?? 'all';

	return (
		<ButtonsSelect
			value={status}
			onChange={(e) => {
				const nextParams = new URLSearchParams(searchParams);
				if (e) nextParams.set('status', e);
				else nextParams.delete('status');
				setSearchParams(nextParams, { replace: true });
			}}
			options={[
				{ name: 'all', value: 'all', hideIcon: true },
				{ name: 'scheduled', value: 'scheduled', accentColor: '#18C096' },
				{
					name: 'ongoing',
					value: 'ongoing',
					accentColor: '#fff',
					iconStyle: { border: '1px solid #9194A1' },
				},
				{ name: 'completed', value: 'completed', accentColor: '#EA6200' },
				{ name: 'attention', value: 'attention', accentColor: '#AD012D' },
			]}
		/>
	);
};
